// import { useState, useEffect } from "react";
// import { toast } from "react-toastify";
// import { fetchProjectById } from "../../apis/projectApi";

// export const useProject = (projectId) => {
//   const [project, setProject] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     // Reset when no ID
//     if (!projectId) {
//       setProject(null);
//       setError(null);
//       setLoading(false);
//       return;
//     }

//     let isCurrent = true;

//     const loadProject = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const data = await fetchProjectById(projectId);
//         if (isCurrent) {
//           setProject(data);
//         }
//       } catch (err) {
//         if (isCurrent) {
//           setError(err.message);
//           toast.error(err.message);
//         }
//       } finally {
//         if (isCurrent) {
//           setLoading(false);
//         }
//       }
//     };

//     loadProject();

//     return () => {
//       isCurrent = false;
//     };
//   }, [projectId]);

//   return { project, loading, error };
// };



import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { fetchProjectById } from "../../apis/projectApi";

export const useProject = (projectId) => {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

 const extractError = (err) => {
      // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
          "Failed to load project. Please try again.",
      };
    };

  useEffect(() => {
    if (!projectId) {
      setProject(null);
      setError(null);
      setLoading(false);
      return;
    }

    let isCurrent = true;

    const loadProject = async () => {
      setLoading(true);
      setError(null);

     try {
        const data = await fetchProjectById(projectId);
        if (isCurrent) {
          setProject(data);
        }
      } catch (err) {
        if (!isCurrent) return;

        const { title, issue } = extractError(err);

        toast.error(
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>,
          { autoClose: 5000 }
        );

        setError({ title, issue });
      } finally {
        if (isCurrent) {
          setLoading(false);
        }
      }
    };

    loadProject();

    return () => {
      isCurrent = false;
    };
  }, [projectId]);

  return { project, loading, error };
};